// Ionic & Angular Imports
import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/observable';
import 'rxjs/add/operator/map';

// Providers
import {InspectionType} from './inspectiontype.service';
import {JurisdictionType} from './jurisdictiontype.service';

export interface Inspection {
    id: number;
    inspection: InspectionType;
    jurisdiction: JurisdictionType;
    inspectorname: string;
    passed: boolean;
    notes: string;
}

@Injectable()
export class rsInspectionSvc 
{ 
    constructor(
        public http: Http, 
    ) {
        // Class constructor
    }

    getInspections(reportId: number) : Observable<Inspection[]> {
        return Observable.create( observer => {

            this.http.get( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/inspection', {
                withCredentials: true
            })
            .map(res => res.json().response.inspection )
            .subscribe( result => {
                observer.next(result);
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });
    }

    addInspection( inspectionTypeId : number, jurisdictinTypeId : number, inspectorname : string, passed: boolean, notes: string, reportId : number ) : Observable<Inspection> {
        return Observable.create( observer => {
            
            let postData = {
                inspectiontypeid: inspectionTypeId,
                jurisdictiontypeid: jurisdictinTypeId,
                inspectorname: inspectorname,
                passed: passed,
                notes: notes
            }

            let body = JSON.stringify(postData);
            let headers = new Headers({
                'Content-Type' : 'application/json'
            });
            let options = new RequestOptions( { headers: headers, withCredentials: true } );
            this.http.post( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/inspection', body, options)
            .map( res => res.json().response.inspection )
            .subscribe( result => {
                observer.next(result);
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });
    }

    updateInspection( inspectionId : number, inspectionTypeId : number, jurisdictinTypeId : number, inspectorname : string, passed: boolean, notes: string, reportId : number ) : Observable<Inspection> {
        return Observable.create( observer => {

            let patchData = {
                inspectiontypeid: inspectionTypeId,
                jurisdictiontypeid: jurisdictinTypeId,
                inspectorname: inspectorname,
                passed: passed,
                notes: notes
            }

            let body = JSON.stringify(patchData);
            let headers = new Headers({
                'Content-Type' : 'application/json'
            });
            let options = new RequestOptions( { headers: headers, withCredentials: true } );
            this.http.patch( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/inspection/' + inspectionId, body, options )
            .map( res => res.json().response.inspection )
                .subscribe( result => {
                    observer.next(result);
                }, err => {
                    observer.error(err);
                }, () => {
                    observer.complete();
                });
        });
    }
    
    deleteInspection( inspectionId : number, reportId : number ) : Observable<void> {
        return Observable.create( observer => {

            this.http.delete( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/inspection/' + inspectionId, {
                withCredentials: true 
            })
            .map( res => res.json() )
            .subscribe( result => {
                observer.next( result );
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/inspection.service.ts